<div class="container-fluid">
  <div class="row pt-4 pl-4" style="font-size: 22px !important;
  font-weight: 400;
  color: #424242;">
    <h5><i class="fa fa-circle" style="color:#800000"></i> &nbsp;Variance Report</h5>
  </div>
<div id="mainContent" class="container">
  <div class="modal-body mt-2">
    <div class="row">
      <div class="col-sm-5">
        <div class="row">
          <label class="col-sm-4 col-form-label">Financial Year</label>
          <div class="col-sm-6">
            <select
              class="form-control form-control-xs mt-1"
              [(ngModel)]="selectedFinancialYear"
              (change)="onFinancialYearSelected()"
            >
              <option value="">Select Year</option>
              <option *ngFor="let finance of financialList" [ngValue]="finance">
                {{ finance.name }}
              </option>
            </select>
          </div>
        </div>
      </div>

      <div class="col-sm-5" *ngIf="!checkMyVaianceReport; else elseBlock" >
        <div class="row">
          <label class="col-sm-4 col-form-label">Partner</label>
          <div class="col-sm-6">
            <select
              ngbAutofocus
              class="form-control form-control-xs"
              id="partner"
              name="partner"
              [(ngModel)]="selectPartner"
              (change)="onPartnerSelected()"
            >
              <option value="">Select Partner Name</option>
              <option *ngFor="let partner of partnerList" [ngValue]="partner">
                {{ partner.firstName }} {{ partner.lastName }}
              </option>
            </select>
          </div>
        </div>
      </div>

      <ng-template #elseBlock>
        <!-- <div class="col-sm-5">
          <div class="row">
            <label class="col-sm-4 col-form-label">Partner</label>
            <div class="col-sm-6">
             <input type="text"  class="form-control form-control-xs" [(ngModel)]="reportingPartnerName">
            </div>
          </div>
        </div> -->

        <div class="col-sm-5">
          <div class="row">
            <label class="col-sm-4 col-form-label">Partner</label>
            <div class="col-sm-6">
              <select
                ngbAutofocus
                class="form-control form-control-xs"
                id="partner"
                name="partner"
                [(ngModel)]="selectPartner"
                (change)="onPartnerSelected()"
              >
                <option value="">Select Partner Name</option>
                <option *ngFor="let partner of partnerArrayList" [ngValue]="partner">
                  {{ partner.reportingPartner.firstName }} {{ partner.reportingPartner.lastName }}
                </option>
              </select>
            </div>
          </div>
        </div>
      </ng-template>

    </div>

    <div class="row">
      <div class="col-sm-5">
        <div class="row">
          <label class="col-sm-4 col-form-label">Clients</label>
          <div class="col-sm-6">
            <mat-form-field appearance="legacy" style="width: 100%">
              <mat-select
                multiple
                [(ngModel)]="selectClient"
                #designateClient="ngModel"
              >
                <mat-option
                  #clientChecked
                  (click)="selectAllClient(designateClient, clientList)"
                  [value]="0"
                  >Select All
                </mat-option>
                <mat-option
                  (click)="getAllAssignmentDetails()"
                  #clientChecked
                  *ngFor="let client of clientList"
                  [value]="client"
                >
                  {{ client.name }}
                </mat-option>
              </mat-select>
            </mat-form-field>
          </div>
        </div>
      </div>

      <div class="col-sm-5">
        <div class="row">
          <label class="col-sm-4 col-form-label">Assignments</label>
          <div class="col-sm-6">
            <mat-form-field appearance="legacy" style="width: 100%">
              <mat-select
                multiple
                [(ngModel)]="selectAssignment"
                #designateAssignment="ngModel"
              >
                <mat-option
                  (click)="
                    selectAllAssignment(designateAssignment, assignmentList)
                  "
                  [value]="0"
                  >Select All
                </mat-option>
                <mat-option
                  #item
                  *ngFor="let assignment of assignmentList"
                  [value]="assignment"
                >
                  {{ assignment.name }}
                </mat-option>
              </mat-select>
            </mat-form-field>
          </div>
        </div>
      </div>
    </div>

    <div class="row">
      <div class="col-sm-5" >
        <div class="row">
          <div class="col-sm-12">
            <div class="form-group mb-0" style="margin-top: -2%">
              <div class="form-check form-check-inline pr-5" *ngIf="!checkMyVaianceReport">
                <input
                  class="form-check-input"
                  type="radio"
                  name="Cost"
                  id="Cost"
                  [(ngModel)]="selectManDays"
                  [value]="0"
                />
                <label class="col-form-label ml-3" style="font-weight: 400"
                  >Cost</label
                >
              </div>
              <div class="form-check form-check-inline">
                <input
                  class="form-check-input"
                  type="radio"
                  name="mandays"
                  id="mandays"
                  [(ngModel)]="selectManDays"
                  [value]="1"
                />
                <label class="col-form-label ml-3" style="font-weight: 400"
                  >Man Days</label
                >
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="col-sm-5">
        <div class="row">
          <div class="col-sm-5">
            <button
              class="btn btn-sm btn-block btn-outline-theme"
              (click)="onViewReport()"
            >
              View Details
            </button>
          </div>
          <div class="col-sm-5"></div>
        </div>
      </div>
    </div>
  </div>
  </div>

  <div class="container pt-3 pb-3" id="mainContent" *ngIf="showFYData">
    <div class="row justify-content-center text-center">
      <span class="bg-theme-title"
        >P G BHAGWAT LLP, Chartered Accountants
      </span>
    </div>
    <div class="row justify-content-center text-center ">
      <span>Suite 102, "Orchard", Dr Pai Marg, Baner, Pune - 411045 </span>
    </div>

    <div class="row justify-content-center text-center mt-2">
        <div *ngIf="showManDaysAfterViewReport; else elseBlock1">
          <span class="bg-theme-title"
            >Financial Year wise Budgeted VS Actual Cost</span
          >
        </div>
        <ng-template #elseBlock1>
          <span class="bg-theme-title"
            >Financial Year wise Budgeted VS Actual Man Days</span
          >
        </ng-template>
        <!-- <span class="bg-theme-title">Financial Year wise Budgeted VS Actual Cost</span> -->
    </div>
    <div class="mt-4">
      <div class="row">
        <div class="col-sm-3"></div>
        <div class="col-sm-9">
          <ngx-charts-bar-vertical-2d
            [results]="forFYBudgetVSActualCostList"
            [gradient]="gradient"
            [xAxis]="showXAxis"
            [yAxis]="showYAxis"
            [legend]="showLegend"
            [showGridLines]="showGridLines"
            [legendPosition]="legentPosition"
            [showXAxisLabel]="showXAxisLabel"
            [showYAxisLabel]="showYAxisLabel"
            [xAxisLabel]="xAxisLabelForFY"
            [yAxisLabel]="yAxisLabel"
            (select)="onSelectFYCost($event)"
            [scheme]="colorScheme"
            [view]="[400, 600]"
            [showDataLabel]="showDataLabel"
          >
          </ngx-charts-bar-vertical-2d>
        </div>
      </div>
    </div>
  </div>

  <div  class="container pt-3 pb-3" id="mainContent"  *ngIf="showPartnerData">
    <div class="row justify-content-center text-center">
      <span class="bg-theme-title"
        >P G BHAGWAT LLP, Chartered Accountants
      </span>
    </div>
    <div class="row justify-content-center text-center ">
      <span>Suite 102, "Orchard", Dr Pai Marg, Baner, Pune - 411045 </span>
    </div>
    <div class="row justify-content-center text-center mt-2">
        <!-- <span class="bg-theme-title">Partner wise Budgeted VS Actual Cost</span> -->
        <div *ngIf="showManDaysAfterViewReport; else elseBlock1">
          <span class="bg-theme-title"
            >Partner wise Budgeted VS Actual Cost</span
          >
        </div>
        <ng-template #elseBlock1>
          <span class="bg-theme-title"
            >Partner wise Budgeted VS Actual Man Days</span
          >
        </ng-template>
    </div>
    <div class="mt-4">
      <div class="row">
        <div class="col-sm-3"></div>
        <div class="col-sm-9">
          <ngx-charts-bar-vertical-2d
            [results]="forPartnerBudgetVSActualCostList"
            [gradient]="gradient"
            [xAxis]="showXAxis"
            [yAxis]="showYAxis"
            [legend]="showLegend"
            [showGridLines]="showGridLines"
            [legendPosition]="legentPosition"
            [showXAxisLabel]="showXAxisLabel"
            [showYAxisLabel]="showYAxisLabel"
            [xAxisLabel]="xAxisLabelForPartner"
            [yAxisLabel]="yAxisLabel"
            (select)="onSelectPartnerCost($event)"
            [scheme]="colorScheme"
            [view]="[400, 600]"
            [showDataLabel]="showDataLabel"
          >
          </ngx-charts-bar-vertical-2d>
        </div>
      </div>
    </div>
  </div>

  <div  class="container pt-3 pb-3" id="mainContent"  *ngIf="showClientData">
    <div class="row justify-content-center text-center">
      <span class="bg-theme-title"
        >P G BHAGWAT LLP, Chartered Accountants
      </span>
    </div>
    <div class="row justify-content-center text-center ">
      <span>Suite 102, "Orchard", Dr Pai Marg, Baner, Pune - 411045 </span>
    </div>
    <div class="row justify-content-center text-center mt-">
        <!-- <span class="bg-theme-title">Client wise Budgeted VS Actual Cost</span> -->
        <div *ngIf="showManDaysAfterViewReport; else elseBlock1">
          <span class="bg-theme-title"
            >Client wise Budgeted VS Actual Cost</span
          >
        </div>
        <ng-template #elseBlock1>
          <span class="bg-theme-title"
            >Client wise Budgeted VS Actual Man Days</span
          >
        </ng-template>
    </div>
    <div class="mt-4">
      <ngx-charts-bar-vertical-2d
        [results]="forClientBudgetVSActualCostList"
        [gradient]="gradient"
        [xAxis]="showXAxis"
        [yAxis]="showYAxis"
        [legend]="showLegend"
        [showGridLines]="showGridLines"
        [legendPosition]="legentPosition"
        [showXAxisLabel]="showXAxisLabel"
        [showYAxisLabel]="showYAxisLabel"
        [xAxisLabel]="xAxisLabelForClient"
        [yAxisLabel]="yAxisLabel"
        (select)="onSelectForClient($event)"
        [scheme]="colorScheme"
        [view]="[1000, 600]"
      >
      </ngx-charts-bar-vertical-2d>
    </div>
  </div>

  <div  class="container pt-3 pb-3" id="mainContent"  *ngIf="showAssignmentData">
    <div class="row justify-content-center text-center">
      <span class="bg-theme-title"
        >P G BHAGWAT LLP, Chartered Accountants
      </span>
    </div>
    <div class="row justify-content-center text-center ">
      <span>Suite 102, "Orchard", Dr Pai Marg, Baner, Pune - 411045 </span>
    </div>
    <div class="row justify-content-center text-center mt-2">
        <!-- <span class="bg-theme-title"
          >Assignment wise Budgeted VS Actual Cost</span
        > -->
        <div *ngIf="showManDaysAfterViewReport; else elseBlock1">
          <span class="bg-theme-title"
            >Assignment wise Budgeted VS Actual Cost</span
          >
          </div>
        <ng-template #elseBlock1>
          <span class="bg-theme-title"
            >Assignment wise Budgeted VS Actual Man Days</span
          >
        </ng-template>
    </div>
    <div class="mt-4">
      <ngx-charts-bar-vertical-2d
        [results]="forAssignmentBudgetVSActualCostList"
        [gradient]="gradient"
        [xAxis]="showXAxis"
        [yAxis]="showYAxis"
        [legend]="showLegend"
        [showGridLines]="showGridLines"
        [legendPosition]="legentPosition"
        [showXAxisLabel]="showXAxisLabel"
        [showYAxisLabel]="showYAxisLabel"
        [xAxisLabel]="xAxisLabelForAssignmnet"
        [yAxisLabel]="yAxisLabel"
        (select)="onSelectForAssignment($event)"
        [scheme]="colorScheme"
        [view]="[1000, 600]"
      >
      </ngx-charts-bar-vertical-2d>
    </div>
  </div>

  <div  class="container pt-3 pb-3" id="mainContent"  *ngIf="showFYRoleData">
    <div class="row">
      <div class="col-sm-3 ml-2" (click)="goBack()">
        <i class="fa fa-arrow-circle-o-left fa-2x"></i>
      </div>
      <div class="col-sm-7">
        <!-- <span class="bg-theme-title">Role wise Budgeted VS Actual Cost</span> -->
        <div *ngIf="showManDaysAfterViewReport; else elseBlock1">
          <span class="bg-theme-title">Role wise Budgeted VS Actual Cost</span>
        </div>
        <ng-template #elseBlock1>
          <span class="bg-theme-title"
            >Role wise Budgeted VS Actual Man Days</span
          >
        </ng-template>
      </div>
    </div>
    <div class="mt-4">
      <ngx-charts-bar-vertical-2d
        [results]="forFYBudgetVSActualCostByRoleList"
        [gradient]="gradient"
        [xAxis]="showXAxis"
        [yAxis]="showYAxis"
        [legend]="showLegendForRole"
        [showGridLines]="showGridLines"
        [legendPosition]="legentPosition"
        [showXAxisLabel]="showXAxisLabel"
        [showYAxisLabel]="showYAxisLabel"
        [xAxisLabel]="xAxisLabelForFYRole"
        [yAxisLabel]="yAxisLabel"
        [scheme]="colorScheme"
        [view]="[1000, 600]"
      >
      </ngx-charts-bar-vertical-2d>
    </div>
  </div>
</div>
